<template>
  <div>
    <div class="status search">
      <div class="field_left">
        <app-input
            inputClass="search"
            id="vyhledavani"
            name="search"
            :label="translations.search"
            inputSize="30"
            type="search"
            v-model="params.search"
            @input="triggerUpdate"
        />
      </div>
      <a
          class="add add_expand"
          :class="{'open': isOpen}"
          @click.prevent="toggleExpandContent"
          title="Přidat párovací šablonu"
      >Přidat párovací šablonu</a>
    </div>

    <form class="filter expand_content" :class="{ 'open': isOpen }" @submit.prevent="submitForm">
      <div class="field_left">
        <app-settings-select
            :label="translations.type"
        >
          <app-select
              selectId="typeSelect"
              name="typeSelect"
              :options="typeOptions"
              v-model="typeSelect"
          />
        </app-settings-select>
      </div>
      <div class="field_right">
        <app-settings-select
            v-if="typeSelect === 'PAIRING_TEMPLATE_CONTENT_ID_TYPE' ||
                    typeSelect === 'PAIRING_TEMPLATE_REGEX_NAME_TYPE'"
            :label="translations.epgSource + (typeSelect === 'PAIRING_TEMPLATE_CONTENT_ID_TYPE' ? ' *' : '')"
        >
          <app-select
              selectId="epgSelect"
              name="epgSelect"
              :options="epgSources.map(v => ({name: v.name, value: v._id}))"
              v-model="epgSelect"
          />
        </app-settings-select>
        <app-settings-select
            v-if="typeSelect === 'PAIRING_TEMPLATE_BROADCAST_TYPE'"
            :label="translations.tvStations"
        >
          <app-select
              selectId="tvStationsSelect"
              name="tvStationsSelect"
              :options="tvStationsOptions"
              v-model="tvStationsSelect"
          />
        </app-settings-select>
      </div>
      <div class="field_left">
        <app-input
            v-if="typeSelect"
            id="expression"
            name="expression"
            required
            :label="translations.expression"
            inputSize="255"
            type="text"
            v-model.trim="expression"
        />
      </div>
      <div class="field_right">
        <app-input
            v-if="typeSelect"
            id="extraCriteria"
            name="extraCriteria"
            :label="translations.extraCriteria"
            inputSize="255"
            type="text"
            v-model.trim="extraCriteria"
        />
        <p class="field" v-if="typeSelect">
          <app-content-save-button :disabled="createDisabled"/>
        </p>
      </div>
    </form>
  </div>
</template>

<script>
import {AUTOCOMPLETE_TITLE} from 'symbols/autocomplete'
import {mapActions, mapState} from 'vuex'
import apiMessagesMixin from '../../mixins/apiMessagesMixin'

export default {
  name: 'templates-search-bar',
  mixins: [
    apiMessagesMixin
  ],
  props: {
    params: {
      type: Object,
      default: () => ({})
    },
    createDisabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      templateExpression: '',
      isOpen: false,
      apiErrors: {},
      typeSelect: '',
      epgSelect: '',
      tvStationsSelect: '',
      expression: '',
      extraCriteria: ''
    }
  },
  computed: {
    ...mapState({
      currentLanguage: state => state.uiLanguages.currentLanguage,
      allTvStations: state => state.tvStations.allTvStations,
      storedEpgSources: state => state.epgSources.epgSources
    }),
    epgSources() {
      if (this.typeSelect === 'PAIRING_TEMPLATE_CONTENT_ID_TYPE') {
        return this.storedEpgSources
      } else {
        return [
          {
            name: this.translations.none,
            value: null
          },
          ...this.storedEpgSources
        ]
      }
    },
    tvStationsOptions() {
      return [{name: this.translations.none, value: ''}, ...this.allTvStations.map(v => ({name: v.name, value: v._id}))]
    },
    translations() {
      return {
        search: this.$gettext('Vyhledávání'),
        template: this.$gettext('Šablona *'),
        epgSource: this.$gettext('Epg zdroj'),
        tvStations: this.$gettext('Tv stanice *'),
        type: this.$gettext('Typ *'),
        expression: this.$gettext('Výraz'),
        extraCriteria: this.$gettext('Extra kritéria'),
        expressionError: this.$gettext('Výraz musí být vyplněn'),
        extraCriteriaError: this.$gettext('Extra kritéria musí být ve správném JSON formátu'),
        tvStationError: this.$gettext('Tv stanice musí být vybrána'),
        epgSourceError: this.$gettext('Zdroj epg musí být vybrán'),
        none: this.$gettext('Nevybráno'),
        contentId: this.$gettext('Content id'),
        regexName: this.$gettext('Regulátní výraz'),
        broadcastName: this.$gettext('Název vysílání'),
        episodeType: this.$gettext('Podle názvu epizody'),
        broadcastType: this.$gettext('Podle názvu vysílání')
      }
    },
    typeOptions() {
      return [
        {name: this.translations.none, value: ''},
        {name: this.translations.contentId, value: 'PAIRING_TEMPLATE_CONTENT_ID_TYPE'},
        {name: this.translations.regexName, value: 'PAIRING_TEMPLATE_REGEX_NAME_TYPE'},
        {name: this.translations.broadcastName, value: 'PAIRING_TEMPLATE_BROADCAST_TYPE'}
      ]
    }
  },
  methods: {
    ...mapActions([
      'createPairingTemplate',
      'appShowErrors',
      'appClearErrors'
    ]),
    triggerUpdate() {
      this.$emit('update')
    },
    async submitForm(e) {
      this.errors.clear()

      if (this.typeSelect === 'PAIRING_TEMPLATE_CONTENT_ID_TYPE' && this.epgSelect === '') {
        this.appShowErrors([this.translations.epgSourceError])
        return
      }

      if (this.expression === '') {
        this.appShowErrors([this.translations.expressionError])
        return
      }

      if (this.extraCriteria && !this.checkJson(this.extraCriteria)) {
        this.appShowErrors([this.translations.extraCriteriaError])
        return
      }

      await this.$validator.validateAll()
      if (this.errors.items.length > 0) {
        this.appShowErrors(this.errors.items.map(v => v.msg))
        return
      }

      const {elements} = e.target
      const result = await this.createPairingTemplate({
        data: {
          showId: Number(this.$route.params.id),
          type: this.typeSelect,
          expression: this.expression,
          extraCriteria: this.extraCriteria,
          tvStation: this.tvStationsSelect === '' ? null : this.tvStationsSelect,
          epgSource: this.epgSelect === '' ? null : this.epgSelect
        }
      }).catch(err => err.response)

      this.handleResponseIfError(result)

      if (result.status === 201) {
        e.target.reset()
        this.$validator.reset()
        this.triggerUpdate()
      }

      this.typeSelect = ''
      this.epgSelect = ''
      this.tvStationsSelect = ''
    },
    handleResponseIfError(response) {
      if (response.status === 500) {
        this.appShowErrors([this.errorTrans.serverError])
      }

      if (response.status === 422) {
        if (response.data.message === 'Model errors: pairingTemplateRegexInvalid') {
          this.appShowErrors([this.apiMessagesMap.pairingTemplateRegexInvalid])
        } else {
          this.appShowErrors([this.apiMessagesMap.pairingTemplateMustBeUnique])
        }
      }

      this.apiErrors = response.data.error
      if (this.apiErrors && this.apiErrors.length) {
        this.mapApiErrorsToErrors()

        if (response.status === 422) {
          this.appShowErrors([this.errorTrans.formError])
        }
      }
    },
    toggleExpandContent() {
      this.isOpen = !this.isOpen
    },
    mapApiErrorsToErrors() {
      this.errors.add(this.apiErrors.map(v => ({field: v.path, msg: this.translateMsg(v.message)})))
    },
    checkJson(json) {
      let isJsonValid = true
      try {
        JSON.parse(json)
      } catch {
        isJsonValid = false
      }

      return isJsonValid
    }
  },
  watch: {
    currentLanguage() {
      if (this.errors.items.length) {
        this.errors.clear()
        this.mapApiErrorsToErrors()
        this.appClearErrors()
      }
    },
    typeSelect(value) {
      if (value === 'PAIRING_TEMPLATE_REGEX_NAME_TYPE') {
        if (this.expression === '') {
          this.expression = '/^' + this.translations.expression +  ' (.+)$/';
        }
      }
    }
  }
}
</script>
